<template>
  <div>
    <page-title pageName="分类管理"/>
    <div class='comm-container'>
      <div class='comm-page-container'>
        <el-row class='pd10'>
          <el-col :span='18'>
            <span class='comm-search-txt'>输入查询：</span>
            <el-input
              v-model='searchValue'
              class='comm-search-con'
              placeholder='分类名称'
              size='small'/>
            <el-button
              size='small'
              type="primary"
              class='ml10' @click='selectBtn'>查询</el-button>
            <el-button
              size='small' @click='resetBtn'>重置</el-button>
          </el-col>
          <el-col
            :span='6'
            class='text-right'>
            <!-- <el-button
              size='small'
              type="primary" @click='showDialogBtn(1)'>添加</el-button> -->
          </el-col>
        </el-row>
        <el-table
          border
          :data="tableData">
          <el-table-column
            sortable
            align='center'
            prop='id'
            label="分类ID"/>
          <el-table-column
            sortable
            align='center'
            prop='typeName'
            label="分类名称"/>
          <el-table-column
            width='300px'
            align='center'
            label="操作">
            <template slot-scope="scope"> 
              <div>
                <el-button size='mini' plain type="primary" @click='showDialogBtn(2,scope.row)'>编辑</el-button>
                <el-button size='mini' :disabled='scope.$index === 0' plain type="primary" @click='onUpItem(scope.row,scope.$index)'>上移</el-button>
                <el-button size='mini' :disabled='scope.$index === tableData.length -1' plain type="primary" @click='onDownItem(scope.row,scope.$index)'>下移</el-button>
                <!-- <el-button size='mini' plain type="danger" @click='delBtn(scope.row)'>删除</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="450px"
      @close="handleClose">

      <el-form :model='typeForm' label-width='100px' label-position="left" ref='typeForm' :rules='typeFormRule'>
        <el-form-item label='分类ID：' v-if='currRow'>
          {{currRow.id}}
        </el-form-item>
        <el-form-item label='分类名称：' prop='typeName'>
          <el-input v-model='typeForm.typeName' placeholder='请输入'></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Classify',
  data () {
    return {
      dialogVisible:false,
      dialogTitle:"新增分类",
      typeFormRule:{
        typeName:[
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      typeForm:{
        typeName:''
      },
      currRow:null,
      tableData: [],
      searchValue: ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData(){
      this.tableData = []
      let params = {
        typeName:this.searchValue
      }
      this.$ajax({
        method:'post',
        url:'goodsType/selectGoodsTypes',
        data:params
      }).then(res => {
        if(res.data.code > 0){
          this.tableData = res.data.list
        }else{
          this.$message.warning(res.data.desc)
        }
      })
    },
    handleClose(){
      this.typeForm.typeName = null
      this.currRow = null
      this.$refs.typeForm.resetFields()
      this.dialogVisible = false
    },
    showDialogBtn(type,item){
      if(type===2){
        this.currRow = JSON.parse(JSON.stringify(item)) 
        this.typeForm.typeName = this.currRow.typeName
      }else{
        this.typeForm.typeName = null
      }
      this.dialogTitle = type === 2 ? '编辑分类' : '新增分类'
      this.dialogVisible = true
    },
    delBtn(item){
      this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            id:item.id,
            typeName:item.typeName,
            typeStatus:-1
          }
          this.$ajax({
            method:'post',
            url:'goodsType/updateGoodsType',
            data:params
          }).then(res => {
            if(res.data.code > 0){
              this.$message.success('删除成功！')
              this.getData()
            }else{
              this.$message.warning(res.data.desc)
            }
          })
        })
    },
    selectBtn(){
      this.getData()
    },
    resetBtn(){
      this.searchValue = null
      this.getData()
    },
    save(){
      let url =''
      let params = {
        typeName:this.typeForm.typeName
      }
      if(this.currRow){
        params.id = this.currRow.id
        url='goodsType/updateGoodsType'
      }else{
        url='goodsType/insertGoodsType'
      }
      this.$refs.typeForm.validate((valid) => {
        if(valid){
          this.$ajax({
            method:'post',
            url:url,
            data:params
          }).then(res => {
            if(res.data.code > 0){
              this.$message.success('保存成功')
              this.getData()
              this.currRow = null
              this.dialogVisible = false
            }else{
              this.$message.warning(res.data.desc)
            }
          })  
        }
      })
      
    },
    // 上移
    onUpItem (item, index) {
      this.tableData.splice(index - 1, 0, item)
      this.tableData.splice(index + 1, 1)
      this.moveAjax(item,this.tableData[index])
    },
    // 下移
    onDownItem (item, index) {
      this.tableData.splice(index + 2, 0, item)
      this.tableData.splice(index, 1)
      this.moveAjax(item,this.tableData[index])
    },
    moveAjax(data1,data2){
      let obj1 = JSON.parse(JSON.stringify(data1))
      let obj2 = JSON.parse(JSON.stringify(data2))
      let temp = obj1.orderId
      obj1.orderId = obj2.orderId
      obj2.orderId = temp
      let params = [
        obj1,obj2
      ]
      this.$ajax({
        method:'post',
        url:'goodsType/updateGoodsTypes',
        data:params
      }).then(res => {
        if(res.data.code > 0){
          this.$message.success('保存成功')
          this.getData()
        }else{
          this.$message.error(res.data.desc)
        }
      })
    }
  }
}
</script>
